<template>
  <BladderChartContent
    :title="$t('text.observation_chart')"
    :observationTypeId="observationTypeId.all"
    :showSummary="false"
    :expandLegend="true"
    :showShareBtn="p('Patients.Charts.Observation.Share')"
    :showPrintBtn="p('Patients.Charts.Observation.Print')"
  />
</template>

<script>
import { observationTypeId } from '@/components/patients/charts/smartzEventsChart/SmartzEventConst.js'
import BladderChartContent from '@/components/patients/incoAssessment/BladderChartContent'
export default {
  data() {
    return {
      observationTypeId
    }
  },
  components: {
    BladderChartContent
  }
}
</script>
